import { Table } from '../../Table';
import useTable from '../../../hooks/useTable';
import { TableComponentProps } from '../types';

const columnLables = {
  side_pocket_rate: {
    name: 'Side Pocket percentage',
    order: 197
  },
  gates_rate: {
    name: 'Gates percentage',
    order: 198
  },
  dealing_suspension_rate: {
    name: 'Dealing Suspension percentage',
    order: 199
  },
  other_arrangement_type: {
    name: 'Other Arrangement Type',
    order: 200
  },
  other_arrangement_rate: {
    name: 'Other arrangement percentage',
    order: 201
  }
};

export function Arragements({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { rows, columns, onChange } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT,
    onChangeFund,
    schema: schema.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT?.field_names ||
      [],
    tableName: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT',
    isMultiFunds,
    // @ts-ignore
    isSingleData: true,
    funds,
    columnLables
  });

  return (
    <Table
      id="reporttables-arragements-table"
      handleChanges={onChange}
      columns={columns}
      rows={rows}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
    />
  );
}
